import { PingMessage } from '../Messages/PingMessage';
import { MessageProcessorBase } from './MessageProcessorBase';
export class PingMessageProcessor extends MessageProcessorBase {
    decode(fieldSet) {
        return [new PingMessage(fieldSet)];
    }
}
